(function () {
  'use strict';

  const _youTubeRegex =
    /https?:\/\/.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/|watch\/|live\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?\/]*).*/i;
  const _vimeoRegex =
    /https?:\/\/(?:www.)?vimeo.com\/(?:channels\/(?:w+\/)?|groups\/(?:[^\/]*)\/videos\/|)(\d+)(?:|\/?)/i;

  const messages = {
    en: '<div>We would like to show you a video, but we may only show this video if you consent to marketing cookies.</div><div><button class="button" onclick="util.updateCookiebotConsent(\'marketing\');">Accept marketing cookies</button></div>',
    nl: '<div>We willen u graag een video laten zien, maar we mogen deze video alleen laten zien als u toestemming geeft voor marketing cookies.</div><div><button class="button" onclick="util.updateCookiebotConsent(\'marketing\');">Accepteer marketing cookies</button></div>',
  };

  function VideoLightbox(targets) {
    if (!targets) throw new Error('Missing selector 😢');

    let elements;
    let clickedElement = null;
    let consentTimeout = 500;

    if (typeof targets === 'string') {
      elements = Array.prototype.slice.call(document.querySelectorAll(targets));
    } else if (typeof targets === 'object') {
      elements = Array.prototype.slice.call(targets);
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        // close any open lightboxes
        closeLightboxes(true);
      }
    });

    elements.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();

        clickedElement = element;

        // close any open lightboxes
        closeLightboxes();

        // create lightbox
        createLightbox(util.isKeyboardEvent(event));
      });
    });

    function createLightbox(focusOnClose) {
      if (!clickedElement) return;

      const videoUrl = clickedElement.href;

      // create lightbox
      const lightbox = document.createElement('div');
      lightbox.classList.add('lightbox');

      // create close button
      const closeButton = document.createElement('a');
      closeButton.classList.add('lightbox__close');
      closeButton.classList.add('button');
      closeButton.classList.add('button--outline');
      closeButton.classList.add('button--round');
      closeButton.setAttribute('aria-label', clickedElement.dataset.closeLabel ?? 'Close lightbox');
      closeButton.href = '#';
      closeButton.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" aria-hidden="true">' +
        '<use xlink:href="/icons/symbol-defs.svg#icon-close-thin"></use>' +
        '</svg>';

      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        closeLightboxes(true);
      });

      // create lightbox inner
      const lightboxInner = document.createElement('div');
      lightboxInner.classList.add('lightbox__inner');

      // show message when cookie consent has not been given
      if (hasMarketingConsent()) {
        const lightboxVideo = document.createElement('div');
        lightboxVideo.setAttribute('role', 'dialog');
        lightboxVideo.classList.add('lightbox__video');
        lightboxVideo.innerHTML = getVideoEmbedHtmlFromUrl(videoUrl);
        lightboxInner.appendChild(lightboxVideo);

        // DATALAYER
        app.dataLayer.pushEvent('videoStart', {
          pageUrl: window.location.pathname,
          videoUrl: clickedElement.href,
        });
      } else {
        const language = document.documentElement.lang ?? 'en';
        const lightboxCookie = document.createElement('div');
        lightboxCookie.setAttribute('role', 'dialog');
        lightboxCookie.classList.add('lightbox__cookie');
        lightboxCookie.classList.add('is-content');
        lightboxCookie.innerHTML = clickedElement.dataset.cookieConsent ?? messages[language];

        lightboxInner.appendChild(lightboxCookie);
      }

      const body = document.querySelector('body');

      // add lightbox to DOM
      lightbox.appendChild(closeButton);
      lightbox.appendChild(lightboxInner);

      body.classList.add('lightbox--open');
      body.appendChild(lightbox);

      // focus on close button
      if (focusOnClose) {
        closeButton.focus();
      }
    }

    function hasMarketingConsent() {
      return typeof Cookiebot.consent !== 'undefined' ? Cookiebot.consent.marketing : false;
    }

    function removeConsentWarning() {
      closeLightboxes();
      createLightbox(true);
    }

    function closeLightboxes(focusOnClickedElement) {
      focusOnClickedElement = focusOnClickedElement || false;

      const lightboxes = document.querySelectorAll('.lightbox');
      if (lightboxes) {
        lightboxes.forEach((lightbox) => {
          lightbox.remove();
        });
      }

      const body = document.querySelector('body');
      body.classList.remove('lightbox--open');

      // switch focus back to clicked element
      if (focusOnClickedElement && clickedElement != null) {
        clickedElement.focus({ preventScroll: true });
        clickedElement = null;
      }
    }

    function getVideoEmbedHtmlFromUrl(url) {
      let youTubeMatch = _youTubeRegex.exec(url);
      let vimeoMatch = _vimeoRegex.exec(url);

      // YouTube
      if (youTubeMatch && youTubeMatch.length >= 2) {
        return (
          '<iframe width="1280" height="720" src="https://www.youtube-nocookie.com/embed/' +
          youTubeMatch[1] +
          '?rel=0&autoplay=1&showinfo=0&vq=hd1080" frameborder="0" allow="autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        );
      }

      // Vimeo
      if (vimeoMatch && vimeoMatch.length >= 2) {
        return (
          '<iframe width="1280" height="720" src="https://player.vimeo.com/video/' +
          vimeoMatch[1] +
          '?autoplay=1&dnt=1&quality=1080p" frameborder="0" allow="autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        );
      }

      return '';
    }

    return {
      closeLightboxes: closeLightboxes,
      removeConsentWarning: removeConsentWarning,
      hasMarketingConsent: hasMarketingConsent,
    };
  }

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = VideoLightbox;
  } else {
    window.VideoLightbox = VideoLightbox;
  }
})();
